import {AuthTokenStorage} from "./AuthTokenStorage";
import {LocalStorage} from "./LocalStorage";
import {makeAutoObservable} from "mobx";
import {UserStorage} from "./UserStorage";
import {NewsStorage} from "./NewsStorage";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";

export default class Session {
    constructor(authenticationMethod) {
        this._authenticationMethod = authenticationMethod
        this._application = undefined;
        const localStorage = new LocalStorage();
        this._authTokenStorage = new AuthTokenStorage(localStorage);
        this._userStorage = new UserStorage(localStorage)
        this._newsStorage = new NewsStorage(localStorage)
        this._active = false;
        makeAutoObservable(this);
    }

    active() {
        this._active = this._authenticationMethod.isUserLoggedIn() && this._userStorage.hasUser() && this._userStorage.hasPermissions()
        return this._active
    }

    withApplication(application){
        this._application = application
    }

    addToken(token) {
        this._authTokenStorage.addToken(token)
    }

    getToken() {
        return this._authTokenStorage.getToken()
    }

    async successfulLoginOf(email) {
        const { permissions } = await this.userPermissionsGranted(email);
        this._userStorage.addUser({email: email, permissions: permissions})
        this.active()
    }

    user() {
        return this._userStorage.getUser()
    }

    userPermissions(){
        return this._userStorage.permissions()
    }

    lastShownNewsDatesByNewsId() {
        return this._newsStorage.lastShownDatesByNewsId()
    }

    markNewsAsShown(newsIds, onDate) {
        this._newsStorage.markNewsAsShown(newsIds, onDate)
    }

    permissions() {
        return this.userPermissions()
    }

    async logOut() {
        await this._authenticationMethod.signOut().then((result) =>
            {
                this._authTokenStorage.removeToken()
                this._active = false
            }
        )
        return this.active();
    }

    async refreshUserToken() {
        const token = await this._authenticationMethod.refreshUserToken()
        this.addToken(token)
    }

    async refreshUserPermissions() {
        if (this._userStorage.hasUser()) {
            const currentUser = this._userStorage.getUser();
            const { permissions } = await this.userPermissionsGranted(currentUser.email);
            this._userStorage.addUser({email: currentUser.email, permissions: permissions});
        }
    }

    async userPermissionsGranted(email) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                return {
                    'permissions': response.permissions()
                }
            },
            handlesError: (response) => {
            }
        });
        return this._application.apiClient().userWithRolesAndPermissionsGranted(responseHandler, email);
    }
}